import _ from "lodash";
import {PRODUCT_DETAIL_KEY} from "../constants/pod.constant";

export {
    preparePrintfulProductsForAddOrUpdate
};

const preparePrintfulProductsForAddOrUpdate = (printfulProductsList, existingProductsList, printfulParentProducts, podDetail) => {
    const processedProducts = {
        add: [],
        update: []
    };

    const processedProductsList = printfulParentProducts.add.concat(printfulParentProducts.update);
    const printfulParentProductsMap = _.keyBy(processedProductsList, 'product_id');
    const printfulProductsMap = _.keyBy(printfulProductsList, 'id');
    const notAvailableProducts = [];

    _.forEach(existingProductsList, (existingProduct, index) => {
        const latestProduct = printfulProductsMap[existingProduct[PRODUCT_DETAIL_KEY.VARIANT_ID]];
        if (_.isEmpty(latestProduct)) {
            existingProduct.notAvailable = true;
            notAvailableProducts.push(existingProduct);
            /*if (!existingProduct.notAvailable) {
                existingProduct.notAvailable = true;
                console.log('Not Available - existingProduct', existingProduct.name);
                notAvailableProducts.push(existingProduct);
            } else {
                existingProduct.updateNeeded = false;
            }*/
        }
    });

    const existingProductsMap = _.keyBy(existingProductsList, PRODUCT_DETAIL_KEY.VARIANT_ID);
    const notAvailableProductsMap = _.keyBy(notAvailableProducts, PRODUCT_DETAIL_KEY.VARIANT_ID);

    _.forEach(printfulProductsList, (printfulProduct, index) => {
        processOtherDetails(printfulProduct, podDetail, printfulParentProductsMap[printfulProduct['product_id']]);

        const existingProduct = existingProductsMap[printfulProduct[PRODUCT_DETAIL_KEY.VARIANT_ID]];
        
        if (_.isEmpty(existingProduct)) {
            processedProducts.add.push(printfulProduct);
        } else {
            const updateNeeded = prepareExistingProductForUpdate(existingProduct, printfulProduct);

            if (updateNeeded) {
                processedProducts.update.push(existingProduct);
            }
        }

        /*if (existingProduct && !existingProduct.updateNeeded && !notAvailableProductsMap[printfulProduct[PRODUCT_DETAIL_KEY.VARIANT_ID]]) {
        }*/
    });

    processedProducts.update = processedProducts.update.concat(notAvailableProducts);

    console.log('Not Available Products -> : ', notAvailableProducts.length);
    console.log('Add Products -> : ', processedProducts.add.length);
    console.log('Update Products -> : ', processedProducts.update.length);

    return processedProducts;
}

const prepareExistingProductForUpdate = (existingProduct, printfulProduct) => {
    let updateNeeded = false;
    printfulProduct.id = existingProduct.id;

    _.forIn(printfulProduct, (value, attribute) => {
        if (attribute !== 'id') {
            // existingProduct[attribute] = value;
            if (existingProduct.hasOwnProperty(attribute)) {
                if (!_.isArray(existingProduct[attribute])) {
                    if (existingProduct[attribute] !== value) {
                        // console.log('CHANGED: ', attribute, ' - new: ', value, ' - old: ', existingProduct[attribute]);
                        existingProduct[attribute] = value;
                        updateNeeded = true;
                    }
                }
            } else {
                existingProduct[attribute] = value;
                updateNeeded = true;
                // console.log('NEW: ', attribute, ' - ', value);
            }
        }
    });

    return updateNeeded;
}

const processOtherDetails = (printfulProduct, podDetail, printfulParentProduct) => {
    printfulProduct.market = podDetail.market;
    printfulProduct.podId = podDetail.id;

    printfulProduct.productType = printfulParentProduct.productType;
    printfulProduct.category = printfulParentProduct.category;
    printfulProduct.parent = printfulParentProduct.name;

    printfulProduct.priceUsd = printfulProduct.price;
    printfulProduct.variantId = printfulProduct.id;

    delete printfulProduct.id;
    delete printfulProduct.price;
    delete printfulProduct.availability_regions;
    delete printfulProduct.availability_status;
    delete printfulProduct.material;
}
